import React from 'react'

const HomeLoader = () => {
    return (
        <div className='bg-neutral-950 min-h-screen w-screen text-red-500 p-9'>

            <div className='flex flex-wrap animate-pulse flex-grow gap-5 justify-center items-center'>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
                <div>

                    <div className='sm:w-96 sm:h-56 h-44 w-80 bg-neutral-700 rounded-2xl'></div>
                    <div className='flex mt-2 mx-1'>
                        <div className='h-12 w-12 rounded-full bg-neutral-700' ></div>
                        <div className='flex flex-col gap-1'>

                            <div className='w-60 rounded-full  mx-3 h-6 bg-neutral-700'></div>
                            <div className='w-48 rounded-full mx-3 h-6 bg-neutral-700'></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeLoader
